<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <div class="borbtm">
      <div class="fw-600 colorred mgb-10">
        温馨提示：以下数据为平台内所有企业合计。
      </div>
      <!-- 运营收益统计 -->
      <!-- <div class="color052173 f28 mgb-20">运营收益统计</div> -->
      <div class="stat ">
        <div class="statBox isHaveDetail">
          <div>平台实收分润（元）</div>
          <!-- <span class="detailsBtn">?</span> -->
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台方实际从空中分账方式收到的分润金额。因银联技术要求，仅能保留两位小数，企业方两位小数后的金额将全部划为平台方分润收益。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">{{ statistic.airPrice }}</div>
        </div>
        <div class="statBox isHaveDetail">
          <div>平台应得分润（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台方应该从空中分账方式收到的分润金额。为保证数据准确性，保留小数点后五位。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">
            {{ statistic.sharePrice }}
          </div>
        </div>
        <div class="statBox isHaveDetail">
          <div>平台分润差额（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台方从空中分账方式中多收到的分润金额。为保证数据准确性，保留小数点后五位。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">{{ statistic.marginPrice }}</div>
        </div>
      </div>
    </div>

    <!-- 查询表单区域 -->
    <div class="bg-white mgt-30 pdt-20">
      <el-form :inline="true" ref="form" :model="listForm" label-width="120px">
        <el-form-item label="分润企业名称">
          <el-select
            v-model="companyId"
            placeholder="全部"
            clearable
            filterable
            @change="getList"
          >
            <el-option
              v-for="(v, i) in pullListArr"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button class="mgl-10" @click="resetCompany">重置</el-button>
      </el-form>
    </div>

    <btns @exec="exec"></btns>

    <!-- 表格区域 -->
    <div class="bg-white mgt-30 pdt-20">
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="companyName" label="分润企业名称" />
        <el-table-column prop="airPrice" label="平台实收分润（元）" />
        <el-table-column prop="sharePrice" label="平台应得分润（元）" />
        <el-table-column prop="marginPrice" label="平台分润差额（元）" />
        <el-table-column prop="name" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="45vh"
    >
      <div class="mgb-10">温馨提示:不填写条件则导出全部</div>
      <el-form ref="exportForm" :model="exportForm" label-width="80px">
        <el-form-item label="企业名称">
          <el-select
            clearable
            filterable
            v-model="exportForm.companyId"
            placeholder="全部"
          >
            <el-option
              v-for="(v, i) in pullListArr"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            v-model="exportForm.orderNo"
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="导出时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd8"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtnSureOne">导 出</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="导出"
      :visible.sync="exportChangeNumVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-descriptions column="5" border title="请选择需要导出的数据">
        <el-descriptions-item v-for="(v, i) in radioArr" :key="i" label="范围">
          <el-radio v-model="radio" :label="v.id" @input="changeRadioInput">{{
            v.start + "-" + v.end + "条"
          }}</el-radio></el-descriptions-item
        >
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportChangeNumVisible = false"
          >关 闭</el-button
        >
        <el-button type="primary" @click="exportNumBtn">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      listForm: {
        companyId: "",
        orderNo: "",
        startTime: "",
        endTime: "",
      },
      companyId: "",
      tableData: [],
      statistic: {},
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEnd8: {
        disabledDate: (time) => {
          let beginDateVal = this.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      page: 1,
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      pullListArr: [],
      exportVisible: false,
      exportForm: {
        companyId: "",
        orderNo: "",
        startTime: "",
        endTime: "",
        type: 1,
      },
      interval: 2000,
      radioArr: [],
      exportChangeNumVisible: false,
    };
  },
  created() {
    this.getstatistic();
    this.getList();
    this.getPullList();
  },
  watch: {},
  methods: {
    getstatistic() {
      this.$api.shareManage.differenceStatistics().then((res) => {
        if (res.code === 200) {
          this.statistic = res.data;
        }
      });
    },
    getPullList() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        this.pullListArr = res.data;
      });
    },
    getList() {
      const params = {};
      if (this.companyId) {
        params.companyId = this.companyId;
      }
      params.pageNum = this.page;
      params.pageSize = this.pageSize;
      this.$api.shareManage.differenceList(params).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        }
      });
    },
    reset() {},
    handleEdit(row) {
      this.$router.push({
        path: "/shareManage/differenceDetail",
        query: {
          id: row.companyId,
        },
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    indexMethod(index) {
      return index + 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.page = val;
    },
    resetCompany() {
      this.companyId = "";
      this.getList();
    },
    export() {
      this.exportVisible = true;
    },
    exportBtnSureOne() {
      let params = {
        companyId: this.exportForm.companyId,
        orderNo: this.exportForm.orderNo,
        startTime: this.exportForm.startTime,
        endTime: this.exportForm.endTime,
        limitStart: 1,
        limitEnd: this.interval,
        type: 0,
      };
      this.$api.shareManage.differenceExportShare(params).then((a) => {
        // const link = document.createElement("a");
        // link.style.display = "none";
        // link.href = URL.createObjectURL(a);
        // link.setAttribute("download", `平台分润差额(1-${a.data}).xls`);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // handleAlert("导出成功", "success");
        // return;
        console.log("aaaaa", a);
        if (a.code == 200) {
          // eslint-disable-next-line no-console
          console.log("aaaaa", a);
          if (Number(a.data) > this.interval) {
            console.log(666);
            this.radioArr = [];
            let id = 1;
            for (let i = 0; i < a.data; i += this.interval) {
              const end = Math.min(i + this.interval - 1, a.data - 1);
              this.radioArr.push({ id, start: i + 1, end: end + 1 });
              id++;
            }
            this.exportVisible = false;
            this.radio = "";
            this.exportChangeNumVisible = true;
          } else {
            // 直接导出
            let topExportData = {
              companyId: this.exportForm.companyId,
              orderNo: this.exportForm.orderNo,
              startTime: this.exportForm.startTime,
              endTime: this.exportForm.endTime,
              limitStart: 1,
              limitEnd: this.interval,
              type: 1,
            };
            this.$api.shareManage
              .differenceExportShareDown(topExportData)
              .then((res) => {
                this.exportVisible = false;
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = URL.createObjectURL(res);
                link.setAttribute(
                  "download",
                  `平台分润差额(1-${res.data}).xls`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                handleAlert("导出成功", "success");
              });
          }
        }
      });
    },
    exportNumBtn() {
      if (!this.radio) {
        handleAlert("请选择条数范围", "error");
        return;
      }
      this.radioArr.forEach((v) => {
        if (this.radio == v.id) {
          this.exportForm.limitStart = v.start;
          this.exportForm.limitEnd = v.end;
        }
      });
      let range = this.radioArr.find((v) => this.radio == v.id);
      if (!range) return;
      let exportData = {
        companyId: this.exportForm.companyId,
        orderNo: this.exportForm.orderNo,
        startTime: this.exportForm.startTime,
        endTime: this.exportForm.endTime,
        limitStart: range.start,
        limitEnd: range.end,
        type: 1,
      };
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.shareManage
            .differenceExportShareDown(exportData)
            .then((res) => {
              if (res.code === 200) {
                this.exportChangeNumVisible = false;
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = URL.createObjectURL(res);
                link.setAttribute(
                  "download",
                  `平台分润差额(${range.start}-${range.end}).xls`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                handleAlert("导出成功", "success");
              }
            });
        })
        .catch(() => {
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.stat {
  display: flex;
  justify-content: space-around;
  .statBox {
    width: 300px;
    height: 150px;
    background: var(--card-bg);
    border-radius: 25px;
    color: #007bef;
    font-size: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

.whatClass {
  width: 20px; /* 调整为适合的宽度 */
  height: 20px; /* 调整为适合的高度 */
  text-align: center;
  border-radius: 50%;
  border: 2px solid #007bef;
  color: #007bef;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  cursor: pointer;
}

.isHaveDetail {
  position: relative;
  .detailsBtn {
    position: absolute;
    right: 25px;
    top: 20px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    color: #ccc;
    font-size: 14px;
    border: 1px solid var(--input-border);
    border-radius: 100%;
    cursor: pointer;
    padding: 0;
  }
}

.tooltipinfo {
  width: 150px;
}
</style>
